//============================================================================
// Name        : index.ts
// Purpose     : Adjustment Requests (Tenant Admin > Adjustment Requests and its
//               Report)
// Author      : Senitron Team
// Copyright   : Copyright 2026 Senitron Corporation. All rights reserved.
//============================================================================
import { InitPageStrict } from "../../index";
import { readData, translator } from "./common";
import { Modals } from "./modals";
import { Queue } from "./queue";

class AdjustmentRequestsPage {
  static start(): AdjustmentRequestsPage | null {
    const root = document.getElementById("ar-root");
    return root ? new AdjustmentRequestsPage(root) : null;
  }

  private modals: Modals;
  private queue: Queue | null = null;

  constructor(root: HTMLElement) {
    const data = readData();
    const t = translator(data.i18n);
    this.modals = new Modals(root, t);
    if (document.getElementById("ar-select-all") || document.getElementById("ar-resume-form")) {
      this.queue = new Queue(root, data, this.modals, t);
    }
  }
}

export function LoadPage(): void {
  InitPageStrict("adjustment_requests index", () => { AdjustmentRequestsPage.start(); });
  InitPageStrict("adjustment_requests report", () => { AdjustmentRequestsPage.start(); });
}
